import { render } from "./ReferenceItem.vue?vue&type=template&id=5f4640b8&scoped=true"
import script from "./ReferenceItem.vue?vue&type=script&lang=js"
export * from "./ReferenceItem.vue?vue&type=script&lang=js"

import "./ReferenceItem.vue?vue&type=style&index=0&id=5f4640b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f4640b8"]])

export default __exports__